import { cn } from "$/lib/utils/functions/misc.functions";
import { Link, useMatchRoute } from "@tanstack/react-router";
import { customColors } from "tailwind.config";
import Flexbox from "../../common/Flexbox";
import type { SidebarItemProps } from "./SidebarItem.types";

export default function SidebarItem({ href, label, Icon }: SidebarItemProps) {
  const matchRoute = useMatchRoute();
  const params = matchRoute({
    to: href,
    caseSensitive: false,
    fuzzy: true, // Allow partial matches like `/dashboard/settings`
  });

  const active = !!params;

  return (
    <Link className="w-full" to={href}>
      <Flexbox
        align="center"
        className={cn(
          "w-full gap-3 rounded-xl p-4 text-sm font-normal text-tertiary-600",
          {
            "bg-primary-300 font-semibold text-secondary": active,
          },
        )}
        row
      >
        {Icon && (
          <div className="shrink-0">
            <Icon
              fill={
                active
                  ? customColors.secondary.DEFAULT
                  : customColors.tertiary[600]
              }
            />
          </div>
        )}
        <p>{label}</p>
      </Flexbox>
    </Link>
  );
}
